<div fxLayout="column" fxFlex="100">
  <div fxFlex="100" fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="70" fxLayout="column">
      <div fxLayout="row">
        <h3 class="ga-dialog-header">Autoryzacja dwuetapowa</h3>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <ol class="ga-instruction">
          <li>Pobierz na telefon aplikację Google Authenticator z Google Play lub App Store</li>

          <li>W aplikacji w prawym dolnym rogu kliknij ikonę "+" i wybierz "Zeskanuj kod QR"</li>

          <li>
            <mat-form-field class="ga-code-input">
              <mat-label>Wprowadź sześciocyfrowy kod z aplikacji</mat-label>
              <input autocomplete="off" [formControl]="googleAuthenticatorCodeControl" maxlength="6" minlength="6" matInput placeholder="Wprowadź wyświetlony 6-cyfrowy kod">
              <mat-error *ngIf="googleAuthenticatorCodeControl.hasError('backendError')">{{googleAuthenticatorCodeControl.getError('backendError')}}</mat-error>
            </mat-form-field>
          </li>
          <li>
            <button mat-stroked-button
                    (click)="enableGoogleAuthenticator()"
                    [disabled]="processingRequest || gaEnabled || !gaForm.valid"
            >
              <mat-icon>save</mat-icon><span> Zatwierdź token 2FA</span>
            </button>
          </li>
          <li>Przy logowaniu zamiast kodu SMS wykorzystuj kod z aplikacji</li>
        </ol>
      </div>
    </div>

    <div fxFlex="30">
      <img class="ga-qrcode" [src]="qrCodeUrl" alt="Google Authenticator QR Code"/>
    </div>
  </div>
</div>
